export default __webpack_public_path__ + "static/media/jost-600-semi.6d4a8165.woff";